import { TAccount } from '@helpers/Accounts/accounts.types';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconAngleRight } from '@iwoca/icons';
import { Button, Text } from '@iwoca/orion-ui';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { PartySVGMultiColour } from '@svgComponents/PartyMultiColourSVG';
import { TopupEligibleSVG } from '@svgComponents/TopupEligibleSVG/TopupEligibleSVG';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { buildLocationWithSearch } from '../../../drawDown/DrawDownHelper';
import { useRepaymentReductionSplitTest } from '../../../topupRequest/TopUpChoiceForm/useRepaymentReductionSplitTest';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    startTopupApplication: (accountId: NonNullable<TAccount['account_id']>) =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            //@ts-expect-error: buildLocationWithSearch is not typed
            location: buildLocationWithSearch({
                pathname: '/request-topup/',
                accountId
            })
        })
});

export const TopupEligibleBanner = connect(
    null,
    mapDispatchToProps
)(({
    accountId,
    startTopupApplication
}: {
    accountId: NonNullable<TAccount['account_id']>;
} & ReturnType<typeof mapDispatchToProps>) => {
    const handleApplyNowClick = () => {
        tracking.ampli.topupEligibleBannerCtaClicked({
            account_id: accountId
        });
        startTopupApplication(accountId);
    };
    const { isInRepaymentReductionSplitTest } =
        useRepaymentReductionSplitTest();

    if (isInRepaymentReductionSplitTest) {
        return (
            <div className="flex gap-m rounded-s border border-success-mid bg-success-lt p-m">
                <PartySVGMultiColour className="size-[40px] shrink-0 min-sm:size-[60px]" />
                <div className="space-y-s">
                    <Text className="text-l font-bold min-sm:text-xl">
                        <FormattedMessage
                            id="_.topup_choice_eligible_banner.title"
                            defaultMessage="Good news, you can now apply to withdraw further funds or reduce your repayments."
                        />
                    </Text>
                    <Text>
                        <FormattedMessage
                            id="_.topup_choice_eligible_banner.description"
                            defaultMessage="Access further funds or reduce your minimum monthly repayment amount by adjusting your loan terms"
                        />
                    </Text>
                    <div className="flex flex-col items-center gap-s min-sm:flex-row">
                        <Button
                            className="w-full min-sm:w-auto"
                            onClick={handleApplyNowClick}
                        >
                            <FormattedMessage
                                id="_.topup_choice_eligible_banner.cta"
                                defaultMessage="Apply now"
                            />
                        </Button>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.topup_choice_eligible_banner.disclaimer"
                                defaultMessage="Applying won't affect your credit score"
                            />
                        </Text>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="col-span-5 grid grid-cols-7 gap-m rounded-s border border-success-mid bg-success-lt p-l max-sm:col-span-full">
                <div className="col-span-1 m-auto max-sm:col-span-full">
                    <TopupEligibleSVG className="h-3xl w-3xl" />
                </div>
                <div className="col-span-6 max-sm:col-span-full max-sm:text-center">
                    <Text className="text-xl font-bold">
                        <FormattedMessage
                            id="_.topup_eligible_banner.banner_title"
                            defaultMessage="You’re eligible to request more funds!"
                        />
                    </Text>
                    <Text className="text-l">
                        <FormattedMessage
                            id="_.topup_eligible_banner.text"
                            defaultMessage="It only takes a few clicks to get these funds into your account*"
                        />
                    </Text>
                </div>
                <div className="col-span-4 max-sm:col-span-full max-sm:text-center min-m:col-start-2">
                    <Button onClick={handleApplyNowClick}>
                        <FormattedMessage
                            id="_.topup_eligible_banner.request_more_funds.cta"
                            defaultMessage="Request more funds"
                        />
                        <IconAngleRight />
                    </Button>
                </div>
                <div className="col-span-2 m-auto max-sm:col-span-full">
                    <Text className="text-xs text-structure-40">
                        <FormattedMessage
                            id="_.topup_eligible_banner.disclaimer"
                            defaultMessage="*Subject to approval"
                        />
                    </Text>
                </div>
            </div>
        </>
    );
});
